import React from "react";
import { Divider, Form, Segment, Popup } from "semantic-ui-react";

const CreateMatrix = ({ context, dimensions, errors, product, translate }) => (
    <div>
        <Divider horizontal>{translate("tools.general.createMatrix.new")}</Divider>


        <div>
            <Divider horizontal>{translate("tools.general.createMatrix.newCode")}</Divider>

            <Segment>
                <Popup
                    trigger={<Form.Input label={translate("tools.general.createMatrix.newCode")}
                            value={product.matrixCode}
                            error={!!(typeof errors !== "undefined" && (errors.matrixCode || errors.createMatrix))}
                            onChange={(e) => {
                                context.setState({
                                    product: {
                                        ...product,
                                        matrixCode: e.target.value
                                    }
                                }, () => {
                                    context.dValidate();
                                });
                            }}
                />}
                    header='Matrix Code'
                    content='Hier muss der Code der neuen Matrix angegeben werden. Dieser muss einzigartig sein uns wenn möglich Bestandteil des Artikelcodes aller Varianten (Jahrgänge) sein. Z.b. RUK4748 für den Egomei RUK47480715'
                    on='focus'
                />
            </Segment>

            <Divider horizontal>{translate("tools.general.createMatrix.newProduct")}</Divider>

            <Segment>
                {
                    product.variations.map((variation, key) => {
                        return (
                            <Form.Dropdown
                                value={variation.id + "&" + variation.code}
                                key={key}
                                error={!!(typeof errors !== "undefined" && (errors.createMatrix && variation.id === 1))}
                                fluid
                                search
                                label={translate("tools.general.dimensions." + dimensions[variation.dimension_id].name)}
                                selection
                                options={dimensions[variation.dimension_id].variations.sort((a, b) => a.order > b.order ? 1 : -1)
                                    .map((dimVariation) => ({
                                        key: dimVariation.id,
                                        text: dimVariation.name,
                                        value: dimVariation.id + "&" + dimVariation.code
                                    }))}
                                onChange={(e, { value }) => {
                                    let variations = product.variations;
                                    let info = value.split("&");
                                    variations[key] = {
                                        dimension_id: variation.dimension_id,
                                        id: info[0],
                                        code: info[1]
                                    };
                                    context.setState(({ product }) => ({
                                        product: {
                                            ...product,
                                            variations
                                        }
                                    }), () => {
                                        context.dValidate();
                                    });
                                }}
                            />
                        );
                    })
                }
            </Segment>

            <Divider horizontal>{translate("tools.general.createMatrix.oldProduct")}</Divider>

            <Segment>
                {
                    product.oldProductVariations.map((variation, key) => {
                        return (
                            <Form.Dropdown
                                value={variation.id + "&" + variation.code}
                                key={key}
                                fluid
                                search
                                error={!!(typeof errors !== "undefined" && (errors.createMatrix && variation.id === 1))}
                                label={translate("tools.general.dimensions." + dimensions[variation.dimension_id].name)}
                                selection
                                options={dimensions[variation.dimension_id].variations.sort((a, b) => a.order > b.order ? 1 : -1)
                                    .map((dimVariation) => ({
                                        key: dimVariation.id,
                                        text: dimVariation.name,
                                        value: dimVariation.id + "&" + dimVariation.code
                                    }))}
                                onChange={(e, { value }) => {
                                    let oldProductVariations = product.oldProductVariations;
                                    let info = value.split("&");
                                    oldProductVariations[key] = {
                                        dimension_id: variation.dimension_id,
                                        id: info[0],
                                        code: info[1]
                                    };
                                    context.setState(({ product }) => ({
                                        product: {
                                            ...product,
                                            oldProductVariations
                                        }
                                    }), () => {
                                        context.dValidate();
                                    });


                                }}
                            />
                        );
                    })
                }
            </Segment>
        </div>
    </div>
);

export default CreateMatrix;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/components/CreateMatrix/index.js